import { type NotificationType } from '@/redux/slices/notificationSlice'
import type { SystemWarningType } from '@/typings/domain'
import ItemWrapper from './ItemWrapper'

export default function SystemWarning({ notification }: { notification: NotificationType }) {
  const activity = notification.activity as SystemWarningType

  if (!activity.warningContent) return null

  return <ItemWrapper notification={notification}>{activity.warningContent}</ItemWrapper>
}
